/** Serializes cloud writes while coalescing rapid changes into the newest snapshot. */
export function latestSnapshotWriter<T,R>(write:(value:T)=>Promise<R>,signature:(value:T)=>string) {
 let pending:T|undefined,activeKey="",running:Promise<R>|undefined;
 return (value:T):Promise<R>=>{
  const key=signature(value);
  pending=running&&key===activeKey?undefined:value;
  if(!running){
   running=(async()=>{let result:R;while(pending!==undefined){const next=pending;pending=undefined;activeKey=signature(next);result=await write(next)}return result!})().finally(()=>{running=undefined;activeKey=""});
  }
  return running;
 };
}
